import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { safeCell } from "./reports";
import { imageToJpeg } from "./accountantPack";
import { pdfToImages } from "./pdfExtract";
import { fmt, today } from "./format";

const TEAL = [13, 148, 136];
export const fileSlug = (s) => String(s || "receipts").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 40) || "receipts";

const rowsOf = (found) => found.map((r) => ({
  Date: r.date || "",
  Store: r.store || r.title || "",
  Description: r.title || "",
  Category: r.category || "",
  Amount: r.amount ?? "",
  Note: r.note || "",
  Status: r.tx ? "Attached" : "In inbox",
  File: r.meta.name || "",
}));

export function exportSearchXLSX(found, title, tot) {
  const rows = rowsOf(found).map((r) => Object.fromEntries(Object.entries(r).map(([k, v]) => [k, safeCell(v)])));
  const ws = XLSX.utils.json_to_sheet(rows.length ? rows : [{ Note: "No receipts" }]);
  XLSX.utils.sheet_add_aoa(ws, [[], ["Total", "", "", "", tot.total, `${tot.receipts} receipt(s), ${tot.transactions} transaction(s) — each transaction counted once`]], { origin: -1 });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Receipts");
  XLSX.writeFile(wb, `receipts-${fileSlug(title)}-${today()}.xlsx`);
}

// List + totals, then one page per receipt photo
export async function exportSearchPDF(found, title, tot, filters, getReceipt, onProgress) {
  const doc = new jsPDF({ unit: "pt", format: "letter" });
  doc.setFont("helvetica", "bold").setFontSize(18).setTextColor(...TEAL).text(`Receipts — ${title || "Search results"}`, 40, 50);
  doc.setFont("helvetica", "normal").setFontSize(10).setTextColor(70).text(filters, 40, 68);
  doc.setFontSize(12).setTextColor(20).text(`${fmt(tot.total)} total · ${tot.receipts} receipt(s) · ${tot.transactions} transaction(s)`, 40, 88);
  autoTable(doc, { startY: 100, head: [["#", "Date", "Store / description", "Category", "Amount", "Note", "Status"]], body: found.map((r, i) => [i + 1, r.date || "", [r.store, r.title].filter(Boolean).filter((v, j, a) => a.indexOf(v) === j).join(" — "), r.category, r.amount != null ? fmt(r.amount) : "", r.note, r.tx ? "Attached" : "Inbox"]), margin: { left: 40, right: 40 }, styles: { fontSize: 8 }, headStyles: { fillColor: TEAL } });
  for (let i = 0; i < found.length; i++) {
    const r = found[i];
    onProgress?.(i + 1, found.length);
    let pages = [];
    try {
      const blob = await getReceipt(r.meta);
      if (blob) pages = r.meta.type === "application/pdf" ? await pdfToImages(await blob.arrayBuffer()) : await imageToJpeg(blob);
    } catch (e) {
      console.error(e);
    }
    (pages.length ? pages : [null]).forEach((img, p) => {
      doc.addPage();
      const W = doc.internal.pageSize.getWidth();
      const H = doc.internal.pageSize.getHeight();
      doc.setFont("helvetica", "bold").setFontSize(12).setTextColor(...TEAL).text(`Receipt #${i + 1}${pages.length > 1 ? ` (page ${p + 1})` : ""}`, 40, 44);
      doc.setFont("helvetica", "normal").setFontSize(9).setTextColor(60).text(`${r.date || ""} · ${r.store || r.title} · ${r.amount != null ? fmt(r.amount) : ""}${r.note ? ` · ${r.note}` : ""}`.slice(0, 130), 40, 60);
      doc.setTextColor(20);
      if (!img) return doc.setFontSize(11).text("This receipt's photo isn't stored on this device.", 40, 100);
      const s = Math.min((W - 80) / img.w, (H - 110) / img.h);
      doc.addImage(img.url, "JPEG", 40 + (W - 80 - img.w * s) / 2, 76, img.w * s, img.h * s);
    });
  }
  const n = doc.getNumberOfPages();
  for (let p = 1; p <= n; p++) {
    doc.setPage(p);
    doc.setFont("helvetica", "normal").setFontSize(8).setTextColor(130).text(`Receipt search · prepared ${today()} · page ${p} of ${n}`, 40, doc.internal.pageSize.getHeight() - 20);
  }
  return doc.output("blob");
}

